const map = {
	"./crosscall.png": 4704,
	"./crosscallx4.png": 8052,
	"./nautiz.png": 5483,
	"./onyx.png": 9434,
	"./pa768.png": 1662,
	"./s52.png": 6794,
	"./samsung.png": 972,
	"./saphir.png": 3139
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6925;